








































































import Vue from 'vue';
import { BvTableFieldArray } from 'bootstrap-vue';
import { SchemaModel, HtmlDomEvent, StoreConstants } from '@/types';
import { ObjectUtils } from '@/utils/objectUtils';
import { MultiValueConstants } from '@/types';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'MultiValueReferencesInput',
  props: {
    fields: {
      type: Array as () => BvTableFieldArray,
      required: true
    },
    value: {
      type: Array,
      required: true
    },
    schemas: {
      type: Array as () => SchemaModel[],
      required: true
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    isReadonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPage: 1,
      searchQuery: '',
      isDynamicFormShown: false,
      schema: [] as SchemaModel[],
      isEditMode: false,
      editItemId: 0,
      isDynamicFormDirty: false
    };
  },
  computed: {
    items(this: any) {
      return this.value;
    },
    formattedfields(this: any) {
      return this.fields.map((field: any) => {
        if (field.key === 'actions') {
          return {
            ...field,
            ...{ tdClass: 'w-10', thClass: 'w-10' }
          };
        }
        return field;
      });
    }
  },
  methods: {
    ...mapActions(StoreConstants.ApplicationDirty.ModuleName, [StoreConstants.ApplicationDirty.Actions.SetApplicationDirty]),
    onShowDynamicFormClicked(this: any) {
      this.isDynamicFormShown = !this.isDynamicFormShown;
    },
    onDynamicFormDirty(this: any, dirty: boolean) {
      this.isDynamicFormDirty = dirty;
    },
    onAddMultiValueReference(this: any) {
      this.isEditMode = false;
      this.schema = ObjectUtils.deepCloneObject(this.schemas);

      this.showDynamicForm();
      this.focusOnFirstField();
    },
    onCancelClickedAsync(this: any) {
      this.hideDynamicForm();
    },
    onSubmitAsync(this: any) {
      const updatedItems = this.isEditMode ? this.editItem() : this.addItem();

      this.$emit(HtmlDomEvent.Input, updatedItems);
      if (this.isEditMode) {
        this.hideDynamicForm();
        return;
      }

      this.initialiseInputForAdd();
    },
    onEditClickedAsync(this: any, item: any) {
      this.isEditMode = true;
      this.editItemId = item[MultiValueConstants.RowIdAlias];
      this.schema = ObjectUtils.deepCloneObject(this.schemas).map((s: any) => ({
        ...s,
        value: item[s.id]
      }));
      this.showDynamicForm();
      this.focusOnFirstField();
    },
    onDeleteClickedAsync(this: any, item: any) {
      const valueExcludingDeletedItem = this.value.filter((x: any) => x[MultiValueConstants.RowIdAlias] !== item[MultiValueConstants.RowIdAlias]);
      const updatedItems = valueExcludingDeletedItem.map((item: any, index: number) => ({
        ...item,
        [MultiValueConstants.RowIdAlias]: index + 1
      }));
      this.$emit(HtmlDomEvent.Input, updatedItems);
    },
    onDoneClicked(this: any) {
      this.hideDynamicForm();
    },
    addItem(this: any): any[] {
      const updatedItems = [...this.value];
      const newItemId = updatedItems.length + 1;

      const newItem = this.schema.reduce(
        (acc: any, schemaField: { id: string; value: any }) => ({
          ...acc,
          [schemaField.id.toLowerCase()]: schemaField.value
        }),
        { [MultiValueConstants.RowIdAlias]: newItemId }
      );

      updatedItems.push(newItem);

      return updatedItems;
    },
    editItem(this: any): any[] {
      const newItem = this.schema.reduce(
        (acc: any, { id, value }: { id: string; value: any }) => {
          acc[id.toLowerCase()] = value;
          return acc;
        },
        { [MultiValueConstants.RowIdAlias]: this.editItemId }
      );
      return this.value.map((item: any) => (item[MultiValueConstants.RowIdAlias] === this.editItemId ? newItem : item));
    },
    focusOnFirstField(this: any) {
      const firstInputId = this.schema[0].id;

      requestAnimationFrame(() => this.$refs.dynamicForm.$refs[firstInputId]?.[0]?.focus());
    },
    initialiseInputForAdd(this: any) {
      this.isEditMode = false;
      this.schema = ObjectUtils.deepCloneObject(this.schemas);
      this.showDynamicForm();
      this.focusOnFirstField();
    },
    hideDynamicForm(this: any) {
      this.isDynamicFormShown = false;
      this.$emit('updating', false);
    },
    showDynamicForm(this: any) {
      this.isDynamicFormShown = true;
      this.$emit('updating', true);
    }
  },
  components: {
    MStoreTable: () => import('../shared/Table/MStoreTable.vue'),
    DynamicForm: () => import('../shared/DynamicForm.vue'),
    MStoreAccordion: () => import('../shared/MStoreAccordion.vue')
  }
});
